// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { useState, useEffect } from 'react'

type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl'

function getBreakpoint(width: number): Breakpoint {
  if (width < 640)  return 'sm'
  if (width < 768)  return 'md'
  if (width < 1024) return 'lg'
  if (width < 1280) return 'xl'
  return '2xl'
}

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(
    () => getBreakpoint(window.innerWidth),
  )

  useEffect(() => {
    function handleResize() {
      setBreakpoint(getBreakpoint(window.innerWidth))
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    breakpoint,
    isMobile:  breakpoint === 'sm' || breakpoint === 'md',
    isTablet:  breakpoint === 'lg',
    isDesktop: breakpoint === 'xl' || breakpoint === '2xl',
  }
}
